import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import alertLabsApi from "../Api/AlertLabsApi";
import { useAuthDataContext } from "../AuthDataProvider";
import { NavLink } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

function LocationDetails(props) {
  const { user } = useAuthDataContext();

  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [locationDetails, setLocationDetails] = useState(null);

  useEffect(() => {
    alertLabsApi.getLocationInformation(props.locationId, user.token).then(
      (result) => {
        setIsLoaded(true);
        setLocationDetails(result);
      },
      (error) => {
        setIsLoaded(true);
        setError(error);
      }
    );
  }, [props.locationId, user.token]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else if (locationDetails !== null) {
    return (
      <Paper>
        <Table classes={{ root: "reactivetable" }}>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                Location Name
              </TableCell>
              <TableCell data-th="Location Name">
                <NavLink
                  to={"/location/dashboard/" + props.locationId}
                  className="Nav_link"
                >
                  {locationDetails.name}
                </NavLink>
                <Tooltip title="AlertAQ" arrow placement="top">
                  <IconButton
                    size="small"
                    style={{ marginLeft: 5, padding: 1, verticalAlign: "middle" }}
                    href={`https://alertaq.com/quickportal?tab=Locations&qID=${props.locationId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Open in AlertAQ"
                  >
                    <img src="/aq_logo.png" alt="AlertAQ" style={{ width: 16, height: 16, display: "block" }} />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Address
              </TableCell>
              <TableCell data-th="Address">{locationDetails.street}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    );
  } else {
    return (
    <Paper>
       <div>Trouble Fetching Location Details</div>
      </Paper>
  )}
}
export default LocationDetails;
